import React, {useState, useEffect} from 'react'


const SVGAnimation = () => {
  const [val, setVal] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setVal(val === 1 ? 0 : 1);
    }, 9000);

    return () => clearInterval(interval);
  }, [val]);
  const primary = "#E6015C";
  const secondary = "#3F3D55";
  const white = "#FFF9FB";

    return (
    <div className="svgWrapper">
       <svg
        xmlns="http://www.w3.org/2000/svg"
        width="600"
        height="600"
        viewBox="0 0 600 600"
        key={val}
      >
        <g className="phoneGroup">
          <path
            className="phoneEdge"
            fill={secondary}
            d="M255.2 371.4V198.6c0-3.2 2.7-5.9 5.9-5.9H339c3.2 0 5.9 2.7 5.9 5.9v172.9c0 3.2-2.7 5.9-5.9 5.9h-77.9c-3.3-.1-5.9-2.7-5.9-6z"
          />
          <circle
            className="phoneButton"
            fill={white}
            cx="300"
            cy="363.1"
            r="6"
          />
          <circle
            className="phoneCamera"
            fill={white}
            cx="284.3"
            cy="203.6"
            r="1.5"
          />
          <path
            className="phoneScreen"
            fill="#BDCCD4"
            d="M262.1 214.3h75.7v135.3h-75.7z"
          />
          <path
            className="phoneSpeaker"
            fill={white}
            stroke="#9AA3B2"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="M292.5 203h15"
          />
          <g className="phoneContentGroup" opacity=".6">
            <path
              fill="#E5EBEE"
              d="M327.8 235.6h-55.3c-1 0-1.9-.9-1.9-1.9v-7.3c0-1 .9-1.9 1.9-1.9h55.3c1 0 1.9.9 1.9 1.9v7.3c0 1.1-.9 1.9-1.9 1.9z"
            />
            <path
              fill="#8CA5B2"
              d="M294.3 338.7h-21.9c-1 0-1.9-.8-1.9-1.9v-25c0-1 .8-1.9 1.9-1.9h21.9c1 0 1.9.8 1.9 1.9v25c0 1-.9 1.9-1.9 1.9z"
            />
            <path
              fill="#8CA5B2"
              d="M327.8 300.3h-55.4c-1 0-1.9-.8-1.9-1.9v-51.7c0-1 .8-1.9 1.9-1.9h55.4c1 0 1.9.8 1.9 1.9v51.7c0 1-.9 1.9-1.9 1.9z"
            />
            <path
              fill="#E5EBEE"
              d="M329 314.7h-25.6c-.4 0-.7-.3-.7-.7v-3.4c0-.4.3-.7.7-.7H329c.4 0 .7.3.7.7v3.4c0 .4-.3.7-.7.7z"
            />
            <path
              fill="#E5EBEE"
              d="M329 338.7h-25.6c-.4 0-.7-.3-.7-.7v-3.4c0-.4.3-.7.7-.7H329c.4 0 .7.3.7.7v3.4c0 .4-.3.7-.7.7z"
            />
            <path
              fill="#E5EBEE"
              d="M329 326.3h-25.6c-.4 0-.7-.3-.7-.7v-3.4c0-.4.3-.7.7-.7H329c.4 0 .7.3.7.7v3.4c0 .4-.3.7-.7.7z"
            />
          </g>
        </g>
        <g className="tabletGroup">
          <path
            className="tabletEdge"
            fill={secondary}
            d="M198.5 404.5v-239c0-7.7 6.3-14 14-14h175c7.7 0 14 6.3 14 14v239c0 7.7-6.3 14-14 14h-175c-7.7 0-14-6.3-14-14z"
          />
          <path
            className="tabletScreen"
            fill="#BDCCD4"
            d="M218.5 386.5v-203c0-2.8 2.3-5 5-5h153c2.8 0 5 2.3 5 5v203c0 2.8-2.3 5-5 5h-153c-2.7 0-5-2.2-5-5z"
          />
          <circle
            className="tabletButton"
            fill={white}
            cx="300"
            cy="406"
            r="6"
          />
          <circle
            className="tabletCamera"
            fill={white}
            cx="300"
            cy="168"
            r="2"
          />
          <g className="maskedTabletContentGroup">
            <g className="tabletContentGroup" opacity=".6">
              <path
                fill="#E5EBEE"
                d="M363.6 217.4H236.9c-1.9 0-3.5-1.6-3.5-3.5v-9.4c0-1.9 1.6-3.5 3.5-3.5h126.7c1.9 0 3.5 1.6 3.5 3.5v9.4c-.1 1.9-1.6 3.5-3.5 3.5z"
              />
              <path
                fill="#8CA5B2"
                d="M288 368.9h-51.1c-1.9 0-3.4-1.5-3.4-3.4v-35.4c0-1.9 1.5-3.4 3.4-3.4H288c1.9 0 3.4 1.5 3.4 3.4v35.4c0 1.9-1.6 3.4-3.4 3.4z"
              />
              <path
                fill="#8CA5B2"
                d="M363.6 312.4H236.8c-1.9 0-3.4-1.5-3.4-3.4v-74.6c0-1.9 1.5-3.4 3.4-3.4h126.8c1.9 0 3.4 1.5 3.4 3.4V309c0 1.9-1.5 3.4-3.4 3.4z"
              />
              <path
                fill="#E5EBEE"
                d="M365.8 333.6h-58.4c-.7 0-1.2-.5-1.2-1.2v-4.5c0-.7.5-1.2 1.2-1.2h58.4c.7 0 1.2.5 1.2 1.2v4.5c0 .7-.5 1.2-1.2 1.2z"
              />
              <path
                fill="#E5EBEE"
                d="M365.8 368.9h-58.4c-.7 0-1.2-.5-1.2-1.2v-4.5c0-.7.5-1.2 1.2-1.2h58.4c.7 0 1.2.5 1.2 1.2v4.5c0 .7-.5 1.2-1.2 1.2z"
              />
              <path
                fill="#E5EBEE"
                d="M365.8 350.6h-58.4c-.7 0-1.2-.5-1.2-1.2v-4.5c0-.7.5-1.2 1.2-1.2h58.4c.7 0 1.2.5 1.2 1.2v4.5c0 .7-.5 1.2-1.2 1.2z"
              />
            </g>
          </g>
        </g>
        <g className="laptopGroup">
          <path
            className="laptopEdgeLeft"
            fill={secondary}
            d="M310 401.5H131.5v-226c0-3.9 3.2-7 7-7H310"
          />
          <path
            className="laptopEdgeRight"
            fill={secondary}
            d="M290 168.5h171.5c3.8 0 7 3.1 7 7v226H290"
          />
          <g className="laptopBaseGroup">
            <path
              className="laptopBase"
              fill={primary}
              d="M487 409v15.5c0 3.8-3.2 7.5-7 7.5H120c-3.8 0-7-3.7-7-7.5V409h374z"
            />
          </g>
          <path
            className="laptopTrackpad"
            fill={white}
            d="M326.7 421.8h-53.4l-5-7.6h63.4"
          />
          <path
            className="laptopScreen"
            fill="#BDCCD4"
            d="M452.7 391.9H147.3c-3.8 0-7-3.1-7-7V185.6c0-3.8 3.2-7 7-7h305.3c3.9 0 7 3.2 7 7v199.3c.1 3.9-3.1 7-6.9 7z"
          />
          <g className="laptopContentGroup" opacity=".6">
            <path
              fill="#E5EBEE"
              d="M437.8 212.3H164.1c-1.9 0-3.5-1.6-3.5-3.5v-9.4c0-1.9 1.6-3.5 3.5-3.5h273.7c1.9 0 3.5 1.6 3.5 3.5v9.4c-.1 1.9-1.6 3.5-3.5 3.5z"
            />
            <path
              fill="#8CA5B2"
              d="M215.1 363.8H164c-1.9 0-3.4-1.5-3.4-3.4V325c0-1.9 1.5-3.4 3.4-3.4h51.1c1.9 0 3.4 1.5 3.4 3.4v35.4c0 1.9-1.5 3.4-3.4 3.4z"
            />
            <path
              fill="#8CA5B2"
              d="M437.8 307.3H164c-1.9 0-3.4-1.5-3.4-3.4v-74.6c0-1.9 1.5-3.4 3.4-3.4h273.8c1.9 0 3.4 1.5 3.4 3.4v74.6c0 1.9-1.5 3.4-3.4 3.4z"
            />
            <path
              fill="#E5EBEE"
              d="M440 328.5H234.6c-.7 0-1.2-.5-1.2-1.2v-4.5c0-.7.5-1.2 1.2-1.2H440c.7 0 1.2.5 1.2 1.2v4.5c0 .6-.5 1.2-1.2 1.2z"
            />
            <path
              fill="#E5EBEE"
              d="M440 345.5H234.6c-.7 0-1.2-.5-1.2-1.2v-4.5c0-.7.5-1.2 1.2-1.2H440c.7 0 1.2.5 1.2 1.2v4.5c0 .7-.5 1.2-1.2 1.2z"
            />
            <path
              fill="#E5EBEE"
              d="M440 363.8H234.6c-.7 0-1.2-.5-1.2-1.2v-4.5c0-.7.5-1.2 1.2-1.2H440c.7 0 1.2.5 1.2 1.2v4.5c0 .7-.5 1.2-1.2 1.2z"
            />
          </g>
        </g>
        <g className="monitorGroup">
          <g className="monitorStandGroup">
            <path
              className="monitorStand"
              fill="#3F3D55"
              d="M386.3 512H374l-20.7-57h-106L226 512h-12.3c-2.6 0-4.7 1.9-4.7 4.5s2.1 4.5 4.7 4.5h172.7c2.6 0 4.7-1.9 4.7-4.5s-2.2-4.5-4.8-4.5z"
            />
          </g>

          <g className="monitorEdgeGroup">
            <path
              className="monitorEdge"
              fill="#494D5D"
              d="M559.7 79h-520C32.5 79 27 84.6 27 91.8V403h546V91.8c0-7.2-6.1-12.8-13.3-12.8z"
            />
            <path
              className="monitorScreen"
              fill="#BDCCD4"
              d="M544.5 383.3h-489c-3.8 0-7-3.1-7-7v-271c0-3.8 3.2-7 7-7h489c3.8 0 7 3.2 7 7v271c0 3.8-3.2 7-7 7z"
            />
            <g className="monitorContentGroup" opacity=".6">
              <path
                fill="#E5EBEE"
                d="M526.8 145H73.2c-3.2 0-5.7-2.6-5.7-5.7v-15.5c0-3.2 2.6-5.7 5.7-5.7h453.5c3.2 0 5.7 2.6 5.7 5.7v15.5c.1 3.1-2.5 5.7-5.6 5.7z"
              />
              <path
                fill="#8CA5B2"
                d="M157.9 364.5H73.1c-3.1 0-5.6-2.5-5.6-5.6v-58.7c0-3.1 2.5-5.6 5.6-5.6h84.7c3.1 0 5.6 2.5 5.6 5.6v58.7c.1 3.1-2.4 5.6-5.5 5.6z"
              />
              <path
                fill="#8CA5B2"
                d="M526.9 272.5H73.1c-3.1 0-5.6-2.5-5.6-5.6v-93.7c0-3.1 2.5-5.6 5.6-5.6h453.7c3.1 0 5.6 2.5 5.6 5.6v93.7c.1 3.1-2.4 5.6-5.5 5.6z"
              />
              <path
                fill="#E5EBEE"
                d="M530.5 306H190.2c-1.1 0-2-.9-2-2v-7.5c0-1.1.9-2 2-2h340.3c1.1 0 2 .9 2 2v7.5c0 1.1-.9 2-2 2z"
              />
              <path
                fill="#E5EBEE"
                d="M530.5 334.3H190.2c-1.1 0-2-.9-2-2v-7.5c0-1.1.9-2 2-2h340.3c1.1 0 2 .9 2 2v7.5c0 1.1-.9 2-2 2z"
              />
              <path
                fill="#E5EBEE"
                d="M530.5 364.5H190.2c-1.1 0-2-.9-2-2V355c0-1.1.9-2 2-2h340.3c1.1 0 2 .9 2 2v7.5c0 1.1-.9 2-2 2z"
              />
            </g>
          </g>
          <path
            className="monitorBottom"
            fill="#E6015C"
            d="M573 403v39c0 7.1-6.1 13-13.3 13h-520c-7.2 0-12.7-5.9-12.7-13v-39h546z"
          />

          <circle
            className="monitorLogo"
            fill="#FFF9FB"
            cx="300"
            cy="426"
            r="10"
          />
        </g>
      </svg>
       </div>
  )
}

export default SVGAnimation